
import React, { useState } from 'react';
import { UserPlus, Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCompany } from '@/contexts/CompanyContext';
import { generateRegistrationLink, copyToClipboard } from '@/utils/registrationLinks';
import { useToast } from '@/hooks/use-toast';

const EmptyStateMessage: React.FC = () => {
  const { currentCompany } = useCompany();
  const { toast } = useToast();
  const companySlug = currentCompany?.company_slug || null;
  const [copied, setCopied] = useState(false);

  const handleCopyAssessmentLink = async () => {
    if (!companySlug) return;

    const link = generateRegistrationLink(companySlug);
    const success = await copyToClipboard(link);

    if (success) {
      setCopied(true);
      toast({
        title: "Link Copied!",
        description: "Share this link to invite candidates"
      });
      setTimeout(() => setCopied(false), 2000);
    } else {
      toast({
        title: "Copy Failed",
        description: "Unable to copy link to clipboard",
        variant: "destructive"
      });
    }
  };

  return (
    <div className="flex flex-col items-center justify-center text-center py-16">
      <div className="w-16 h-16 rounded-xl bg-muted/50 border border-border/50 flex items-center justify-center mb-6">
        <UserPlus className="h-8 w-8 text-muted-foreground/60" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">No candidates yet</h3>
      <p className="text-sm text-muted-foreground max-w-sm mb-6">
        Get started by inviting candidates to complete the full assessment.
      </p>
      <Button
        onClick={handleCopyAssessmentLink}
        disabled={!companySlug}
        className="gap-2"
      >
        {copied ? (
          <>
            <Check className="h-4 w-4" />
            Link Copied!
          </>
        ) : (
          <>
            <Copy className="h-4 w-4" />
            Copy Assessment Link
          </>
        )}
      </Button>
    </div>
  );
};

export default EmptyStateMessage;
